import { useMemo } from "react";
import { usePickslipStore } from "../stores/pickslipStore";
import type { PickslipPick } from "../types/PickslipPick";
import type { ProcessedEntry } from "@/hooks/firestore/betting/useEntries";
import { isPickemsEntry } from "features/entries/util/type-guards";

export const useNewPicks = (entry?: ProcessedEntry): PickslipPick[] => {
  const picksInPickslip = usePickslipStore((s) => s.picks);

  return useMemo(() => {
    const picks = picksInPickslip ?? [];
    if (!entry || !isPickemsEntry(entry)) return picks;

    return picks.filter(
      (pick) =>
        !entry.data?.selections?.some(
          (pickInEntry) => pickInEntry.event.eventId === pick.eventId,
        ),
    );
  }, [picksInPickslip, entry]);
};
